<div class="ask-ai-dialog">
  <div class="dialog-header">
    <h2>Ask AI</h2>
  </div>
  
  <div class="dialog-content">
    <div class="form-group">
      <label for="question">Your Question:</label>
      <textarea
        id="question"
        [(ngModel)]="question"
        placeholder="Enter your question here. Provide the user's GID or email and the subscription you are looking for.
        (e.g., Why is this subscription 851725288827 assigned to Z00LLLL?)"
        class="question-input"
        rows="4"
      ></textarea>
    </div>
    
    <div *ngIf="responseText && !isLoading" class="response-section">
      <h3>Response:</h3>
      <ng-container *ngIf="parsedResponseParts as parts; else plainResponse">
        <div class="response-content" [innerHTML]="renderResponseHtml(parts.before)"></div>
        <div class="details-section">
          <button type="button" class="details-toggle" (click)="detailsExpanded = !detailsExpanded">
            <span>{{ detailsExpanded ? '▲ Hide details' : '▼ Show details' }}</span>
          </button>
          <div class="details-body" *ngIf="detailsExpanded">
            <div class="response-content" [innerHTML]="renderResponseHtml(parts.details)"></div>
          </div>
        </div>
        <div class="response-content" *ngIf="parts.after" [innerHTML]="renderResponseHtml(parts.after)"></div>
      </ng-container>
      <ng-template #plainResponse>
        <div class="response-content" [innerHTML]="renderResponseHtml(responseText)"></div>
      </ng-template>
    </div>

    <div *ngIf="dataSourcesUsed.length > 0 && !isLoading" class="response-section">
      <h3>Data Sources Used:</h3>
      <div class="response-content">{{ dataSourcesUsed.join(', ') }}</div>
    </div>
    
    <div *ngIf="isLoading" class="loading">
      <si-loading-spinner></si-loading-spinner>
      <p>It is progressing, it might take a while (up to 3 minutes).</p>
    </div>
    
    <div *ngIf="error" class="error-message">
      {{ error }}
    </div>
  </div>
  
  <div class="dialog-actions">
    <button 
      class="btn btn-primary btn-submit" 
      (click)="onSubmit()"
      [disabled]="!question.trim() || isLoading"
    >
      Ask AI
    </button>
    <button 
      class="btn-cancel" 
      (click)="onCancel()"
      [disabled]="isLoading"
    >
      Close
    </button>
  </div>
</div>
